var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.5 6.5 4 6m9-11-9 11",
    strokeWidth: 3,
    fillRule: "evenodd",
    strokeLinecap: "round",
    stroke: "currentColor"
  })));
};

export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNCI+CiAgICA8ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiPgogICAgICAgIDxnIHN0cm9rZS13aWR0aD0iMyI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTS41IDUuNUw0LjUgMTEuNU0xMy41LjVMNC41IDExLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNDU3LjAwMDAwMCwgLTY2Mi4wMDAwMDApIHRyYW5zbGF0ZSgyNDQzLjAwMDAwMCwgNDQxLjAwMDAwMCkgdHJhbnNsYXRlKDE1LjAwMDAwMCwgMjIyLjAwMDAwMCkiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";